import { render, staticRenderFns } from "./HeadlinePublishDate.vue?vue&type=template&id=4d27ec96"
import script from "./HeadlinePublishDate.vue?vue&type=script&lang=ts"
export * from "./HeadlinePublishDate.vue?vue&type=script&lang=ts"
import style0 from "./HeadlinePublishDate.vue?vue&type=style&index=0&id=4d27ec96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports